import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { agentInfo } from '../mockData';

export const Header = ({ onContactClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md border-b border-stone-200' : 'bg-transparent'
      }`}
      data-testid="site-header"
    >
      <div className="container mx-auto px-6 lg:px-12 py-5">
        <div className="flex items-center justify-between">
          {/* Brand: Rustem + RE/MAX balloon logo */}
          <div className="flex items-center gap-4">
            <div className="text-xl font-light tracking-tight text-stone-900" data-testid="brand-name">
              Rustem<span className="text-stone-400">.</span>
            </div>
            <div className="hidden md:flex items-center gap-2 pl-4 border-l border-stone-300">
              <img
                src="https://customer-assets.emergentagent.com/job_imoveis-faro-pt/artifacts/pvj0xi3c_bala%CC%83o%20SEM%20SOMBRA%20%281%29.png"
                alt="RE/MAX Platina"
                className="h-8 w-auto"
                data-testid="remax-balloon-header"
              />
              <span className="text-[11px] text-stone-500 tracking-wide uppercase">Platina</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-10">
            <button
              onClick={() => scrollToSection('services')}
              data-testid="nav-services"
              className="text-sm font-medium text-stone-700 hover:text-stone-900 transition-colors"
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('about')}
              data-testid="nav-about"
              className="text-sm font-medium text-stone-700 hover:text-stone-900 transition-colors"
            >
              Sobre
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              data-testid="nav-testimonials"
              className="text-sm font-medium text-stone-700 hover:text-stone-900 transition-colors"
            >
              Testemunhos
            </button>
          </nav>

          {/* CTA */}
          <div className="hidden md:block">
            <Button
              onClick={onContactClick}
              data-testid="header-contact-button"
              className="bg-stone-900 hover:bg-stone-800 text-white text-sm font-medium tracking-wide rounded-none px-6"
            >
              Contactar
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-stone-700"
            data-testid="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-6 pt-6 border-t border-stone-200">
            <nav className="flex flex-col gap-5">
              <button onClick={() => scrollToSection('services')} className="text-left text-sm font-medium text-stone-700">Serviços</button>
              <button onClick={() => scrollToSection('about')} className="text-left text-sm font-medium text-stone-700">Sobre</button>
              <button onClick={() => scrollToSection('testimonials')} className="text-left text-sm font-medium text-stone-700">Testemunhos</button>
              <Button
                onClick={onContactClick}
                className="bg-stone-900 hover:bg-stone-800 text-white text-sm font-medium rounded-none w-full mt-2"
              >
                Contactar
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
